import { useQuery } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

export interface IConversationMessage {
	_id: string;
	text: string;
	from: string;
	to: string;
	username: string;
	conversationId: string;
	createdAt: string;
	status: string;
	deletedAt?: string;
}

const EMPTY: IConversationMessage[] = [];

export const useRequestGetConversationMessages = (conversationId: string) => {
	const { isLoading, data, error } = useQuery({
		queryKey: ['report-conversation', conversationId],
		enabled: !!conversationId,
		queryFn: () =>
			apiClient
				.get<IConversationMessage[]>(routes.api.reports.conversation(conversationId))
				.then(handleApiResponse)
	});

	return {
		messages: data ?? EMPTY,
		isLoadingMessages: isLoading,
		error
	};
};
